import {
    DesignTokens,
    GivelifyButton,
    GivelifyFormTextField,
    GivelifyLink,
} from '@givelify/ui';
import { styled } from '@mui/material';

export const Form = styled('form')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        width: 368,
    },
}));

export const TextFieldWrapper = styled('div')(({ theme }) => ({
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
        marginBottom: 8,
    },
    '& .left-helper-text': {
        color: `${DesignTokens.color.globalGenerosityOrange400} !important`,
    },
}));

export const FormTextField = styled(GivelifyFormTextField)(() => ({
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: `${DesignTokens.color.globalGenerosityOrange400} !important`,
            },
        },
    },
    '& .MuiInputLabel-outlined': {
        '&.Mui-focused': {
            color: `${DesignTokens.color.globalGenerosityOrange400} !important`,
        },
    },
})) as typeof GivelifyFormTextField;

export const ActionRow = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'right',
    marginBottom: 33,
    marginTop: 16,
    [theme.breakpoints.down('sm')]: {
        marginBottom: 24,
        marginTop: 8,
    },
}));

export const CheckBoxContent = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
}));

const OrangeGhostButton = styled(GivelifyButton)(() => ({
    paddingLeft: 8,
    paddingRight: 8,
}));

export const ForgotPasswordButton = styled(OrangeGhostButton)(() => ({
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    '&:hover': {
        color: DesignTokens.color.globalGenerosityOrange600,
    },
}));

export const SignInButton = styled(GivelifyButton)(({ isLoading }) => ({
    fontWeight: 800,
    fontSize: '16px',
    lineHeight: '20px',
    marginTop: '24px',
    backgroundColor: `${DesignTokens.color.globalGenerosityOrange400} ${
        isLoading ? '!important' : ''
    }`,
    '&:hover': {
        backgroundColor: `${DesignTokens.color.globalGenerosityOrange600}`,
    },
}));

export const CreateAccountRow = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginTop: 45,
    [theme.breakpoints.down('sm')]: {
        marginTop: 24,
    },
}));

export const SignUpButton = styled(OrangeGhostButton)(() => ({
    display: 'inline-block',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
}));

export const OrangeLink = styled(GivelifyLink)(() => ({
    color: DesignTokens.color.globalGenerosityOrange400,
    '&:hover': {
        color: DesignTokens.color.globalGenerosityOrange600,
        textDecoration: 'none',
    },
}));

export const NotVerifiedList = styled('ul')(() => ({
    color: DesignTokens.color.globalGenerosityOrange400,
    paddingLeft: '24px',
    marginTop: 0,
}));

export const NotVerifiedSupportLink = styled(GivelifyLink)(() => ({
    color: DesignTokens.color.globalGenerosityOrange400,
    textDecoration: 'underline',
    '&:hover': { color: DesignTokens.color.globalGenerosityOrange600 },
}));
